import { render, staticRenderFns } from "./CitimeLayout.vue?vue&type=template&id=338c4e96&scoped=true"
import script from "./CitimeLayout.vue?vue&type=script&lang=js"
export * from "./CitimeLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338c4e96",
  null
  
)

export default component.exports